angular.module('picmonic-common')
    .factory("MenuService", ["WordPressMenuResource", function(WordPressMenuResource){
        return MenuService = {
            navigation: WordPressMenuResource.get({'resource':'menus', 'resource_id': 374}),
            footer: WordPressMenuResource.get({'resource':'menus', 'resource_id': 375})
        };
    }]);